import React from 'react';
import { Box, TextField } from '@mui/material';
import { NotesOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateComplianceNotes } from '../../../state';

/**
 * NotesSection - Compliance notes field
 * Contains additional notes text area
 */
export const NotesSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentComplianceItem } = useAppSelector(state => state.compliance);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateComplianceNotes({ notes: event.target.value }));
  };

  return (
    <Box>
      <SectionHeader
        icon={<NotesOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Notes"
      />
      <SectionPaper>
        <TextField
          label="Notes"
          size="small"
          fullWidth
          multiline
          minRows={3}
          value={currentComplianceItem?.notes || ''}
          onChange={handleChange}
          InputProps={{
            sx: {
              alignItems: 'flex-start',
              '& .MuiInputBase-input': {
                paddingTop: '8px',
              }
            }
          }}
        />
      </SectionPaper>
    </Box>
  );
};

export default NotesSection;
